import { BaseResource } from 'e100-data-providers';
import { TRestProvider } from 'dataSources/types/restProvider';
import {
  FavoriteCatalogsResponse,
  CreateFavoriteCatalogResponse,
  CreateFavoriteCatalog,
  AddStationToCatalog,
  RemoveStationFromCatalog,
  GetCatalogStations,
  GetCatalogStationsResponse,
  FavoriteFolder,
} from './types';

export * from './types';

class FavoriteCatalogs extends BaseResource {
  path: string = '';

  constructor(provider: TRestProvider) {
    super(provider);
    this.path = 'v1/favorite';
  }

  getFavoriteCatalogs(): FavoriteCatalogsResponse {
    return this.getChildResource(`folder/names`).getItems();
  }

  createFavoriteCatalog(
    newCatalog: CreateFavoriteCatalog,
  ): CreateFavoriteCatalogResponse {
    return this.send(
      this.getChildResource('folder').request.post().setBody(newCatalog),
    );
  }

  addStationToFavoriteCatalog(addToCatalogObj: AddStationToCatalog) {
    return this.send(
      this.getChildResource('folder/stations')
        .request.post()
        .setBody(addToCatalogObj),
    );
  }

  removeStationFromFavoriteCatalog(
    removeFromCatalogObj: RemoveStationFromCatalog,
  ) {
    return this.send(
      this.getChildResource(
        `folder/stations?folderId=${removeFromCatalogObj.folderId}&stationCode=${removeFromCatalogObj.stationCode}`,
      ).request.del(),
    );
  }

  removeCatalog(id: number) {
    return this.send(this.getChildResource(`folder/${id}`).request.del());
  }

  renameCatalog(folder: FavoriteFolder) {
    return this.send(
      this.getChildResource('folder').request.put().setBody(folder),
    );
  }

  getCatalogStations(
    catalogStationsObj: GetCatalogStations,
  ): GetCatalogStationsResponse {
    return this.getChildResource(
      `folder/stations?folderId=${catalogStationsObj.folderId}`,
    ).getItems();
  }
}

export default FavoriteCatalogs;
